'use client';

import { useIsMobile } from './use-is-mobile';

/**
 * 600px(sm breakpoint) 기준으로 데스크탑 여부를 반환하는 훅
 * useIsMobile의 반대 값을 반환하여 일관성 있게 동작
 * @returns {boolean} 데스크탑이면 true, 모바일이면 false
 */
export function useIsDesktop(): boolean {
  return !useIsMobile();
}
